import React, { useEffect, useState } from "react";
import { auth } from "../Firebase";
import { Navigate, Link } from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  updateProfile,
  sendSignInLinkToEmail,
  sendEmailVerification,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";
import { useAuth } from "./Context/AuthContext";
import googleIcon from "./images/google-icon.png";
import Axios from 'axios';

// class Signup extends React.Component {
const Signup = () => {
  const { appUser, setUser, isLogin, setLogin } = useAuth();

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const gprovider = new GoogleAuthProvider();
  const actionCodeSettings = {
    // URL you want to redirect back to. The domain (www.example.com) for this
    // URL must be in the authorized domains list in the Firebase Console.
    url: "http://localhost:3000/",
    // This must be true.
    handleCodeInApp: true,
  };

  const handleSignup = async (email, password) => {
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      // if (user && !user.emailVerified) {
      //   sendEmailVerification()
      //     .then(() => {
      //       alert("Email verification link is sent");
      //     })
      //     .catch((error) => {
      //       console.log("Error in Email Verification: " + error);
      //     });
      // }
      let user = userCredential.user;
      try{
          const response=await Axios.post('https://fitness-junction-bots.onrender.com/api/cuftdata',{'userEmail':user.email});
          console.log(response);
      }catch(error){
          console.log(error);
      }
      await updateProfile(auth.currentUser, { displayName: username }).catch(
        (err) => console.log(err)
      );
      // console.log(user.displayName);
      setUser(user);

      setLogin(true);
    } catch (error) {
      console.log(error);
      // alert(error.message);
    }
  };

  function signInWithGoogle() {
    signInWithPopup(auth, gprovider)
      .then(async (result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        // console.log(token);
        const user = result.user;
        //.././......For Context API
        setUser(user);
        setLogin(true);
        console.log("Successfull SignIN");
        try{
          const response=await Axios.post('https://fitness-junction-bots.onrender.com/api/cuftdata',{'userEmail':user.email});
          console.log(response);
        }catch(error){
          console.log(error);
        }
        // IdP data available using getAdditionalUserInfo(result)
        // ...
      })
      .catch((error) => {
        // Handle Errors here.
        console.log("Error occured while signin" + error);
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.customData.email;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        // ...
      });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    await handleSignup(email, password);
  };
  console.log(appUser);
  if (isLogin) {
    return <Navigate to="/" />;
  }

  return (
    <div className="authentication-container">
      <div className="signup-page">
        <h2>Sign Up</h2>
        <form className="authentication-form" onSubmit={handleSubmit}>
          <label>
            Name:
            <input
              type="text"
              value={username}
              className="form-control"
              onChange={(e) => setUsername(e.target.value)}
            />
          </label>
          <label>
            Email:
            <input
              type="email"
              value={email}
              className="form-control"
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <label>
            Password:
            <input
              type="password"
              value={password}
              className="form-control"
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <br />

          <div className="d-flex justify-content-between align-items-start">
            <button type="submit" className="btn bot-btn p-2">
              Sign Up
            </button>
            <button
              className="google-login-btn border-0 btn btn-outline-light w-25 "
              onClick={signInWithGoogle}
            >
              <img
                src={googleIcon}
                alt="Google Icon"
                className="google-icon w-50 shadow-sm rounded-circle"
              ></img>
            </button>
          </div>
        </form>

        <p>
          Already have an account? <Link to="/login">Login</Link>
        </p>
      </div>
    </div>
  );
};
export default Signup;
